import React, { createContext, useContext, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';

interface I18nContextType {
  t: (key: string, options?: any) => string;
  i18n: any;
  changeLanguage: (lng: string) => Promise<any>;
  currentLanguage: string;
}

const I18nContext = createContext<I18nContextType | undefined>(undefined);

interface I18nProviderProps {
  children: ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { t, i18n: i18nInstance } = useTranslation();

  const changeLanguage = async (lng: string) => {
    return await i18nInstance.changeLanguage(lng);
  };

  const value: I18nContextType = {
    t,
    i18n: i18nInstance,
    changeLanguage,
    currentLanguage: i18nInstance?.language || 'zh',
  };

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};
